module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-grey-536e6f0bbb8c36c91023c4b308ff71fd.svg";